import { render, staticRenderFns } from "./SliderBuyOnlineMain.vue?vue&type=template&id=7c7dea74&scoped=true&"
import script from "./SliderBuyOnlineMain.vue?vue&type=script&lang=js&"
export * from "./SliderBuyOnlineMain.vue?vue&type=script&lang=js&"
import style0 from "./SliderBuyOnlineMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SliderBuyOnlineMain.vue?vue&type=style&index=1&id=7c7dea74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7dea74",
  null
  
)

component.options.__file = "SliderBuyOnlineMain.vue"
export default component.exports